type EndorsementHandlersParams = {
	slug: string;
	navigate: (path: string) => void;
	track: (event: string) => Promise<boolean>;
	endorsementToDelete: string | null;
	setEndorsementToDelete: (id: string | null) => void;
	setIsDeleteModalOpen: (open: boolean) => void;
	setIsHelpModalOpen: (open: boolean) => void;
	setIsContentExpanded: (fn: (prev: boolean) => boolean) => void;
	deleteEndorsementAction: (id: string) => Promise<boolean>;
};

type EndorsementHandlersReturn = {
	handleAddAnother: () => void;
	handleViewOnPetition: () => void;
	handleEdit: (id: string) => void;
	handleRemove: (id: string) => void;
	handleSeeExampleClick: () => void;
	handleConfirmDelete: () => Promise<void>;
	handleToggleContentExpansion: () => void;
};

export function useEndorsementHandlers({
	slug,
	navigate,
	track,
	endorsementToDelete,
	setEndorsementToDelete,
	setIsDeleteModalOpen,
	setIsHelpModalOpen,
	setIsContentExpanded,
	deleteEndorsementAction,
}: EndorsementHandlersParams): EndorsementHandlersReturn {
	const handleAddAnother = () => {
		void track('add_petition_endorsement');
		navigate(`/p/${slug}/dashboard/endorsements/add`);
	};

	const handleViewOnPetition = () => {
		void track('view_petition_from_endorsements');
		navigate(`/p/${slug}`);
	};

	const handleEdit = (endorsementId: string) => {
		void track('edit_petition_endorsement');
		navigate(`/p/${slug}/dashboard/endorsements/edit/${endorsementId}`);
	};

	const handleRemove = (endorsementId: string) => {
		void track('delete_petition_endorsement');
		setEndorsementToDelete(endorsementId);
		setIsDeleteModalOpen(true);
	};

	const handleSeeExampleClick = () => {
		void track('petition_manage_endorsements_example_click');
		setIsHelpModalOpen(true);
	};

	const handleConfirmDelete = async () => {
		if (!endorsementToDelete) return;
		await deleteEndorsementAction(endorsementToDelete);
	};

	const handleToggleContentExpansion = () => {
		setIsContentExpanded((prev) => !prev);
	};

	return {
		handleAddAnother,
		handleViewOnPetition,
		handleEdit,
		handleRemove,
		handleSeeExampleClick,
		handleConfirmDelete,
		handleToggleContentExpansion,
	};
}
